//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "fixed-bottom",
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      inViewPort: true,
      observer: null,
    };
  },
};
